export var URL_TYPES = {
  CDMS: 'CDMS',
  DSE: 'DSE',
  TDP: 'TDP',
  MEDIA: 'MEDIA',
  DATA: 'DATA'
};